import * as THREE from "three";

const DEBUG_MATERIAL = new THREE.MeshBasicMaterial({
  transparent: true,
  opacity: 1,
  side: THREE.FrontSide,
  depthTest: false,
  depthWrite: false,
});

type Props = {
  color?: THREE.ColorRepresentation;
  opacity?: number;
  wireframe?: boolean;
};

const createDebugMaterial = (props: Props = {}) => {
  const { color = Math.random() * 0xffffff, wireframe = false, opacity = 1 } = props;
  const material = DEBUG_MATERIAL.clone();
  material.color = new THREE.Color(color);
  material.wireframe = wireframe;
  material.opacity = opacity;
  return material;
};

export { createDebugMaterial };
